import axios from 'axios';
import { user } from '../store';
import apiClientConfig from './config';

const API = apiClientConfig[process.env.NODE_ENV || 'development'];
const PLATFORM = {
  plat: 'wa',
  plat_name: '51jsy'
};

const MP_PLATFORM = {
  plat: 'wp',
  plat_name: 'gjgj'
};

export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface APIConfig {
  defaultToken?: string;
}

async function apiRequest(
  method: Method,
  url: string,
  data: any,
  config: APIConfig
) {
  let requestData = data;
  let params = data;

  if (method === 'GET') {
    requestData = null;
  } else {
    params = null;
  }

  const token = user.token;

  const response = await axios(url, {
    data,
    headers: {
      token
    },
    method,
    params
  });

  if (response.data.status === 80003) {
    user.login();
  }

  return response.data;
}

function createClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return (data?: any, apiConfig: APIConfig = {}) => {
    const config = {
      ...defaultConfig,
      ...apiConfig
    };

    const requestData = {
      ...defaultData,
      ...data
    };

    return apiRequest(method, url, requestData, config);
  };
}

function createBaseClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.BASE_HOST + url, defaultData, defaultConfig);
}

function createJobClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.JOB_HOST + url, defaultData, defaultConfig);
}

const apiClient = {
  base: {
    /**
     * 资产信息
     * 0041
     */
    account: createBaseClient('GET', '/v1/account', PLATFORM),
    /**
     * 0025-发送短信
     * plat, plat_name, phone,
    **/
    sendVcode: createBaseClient('GET', '/v1/vcode'),
    /**
     * 0063-绑定手机
     * plat, plat_name, phone, vcode,
     * source_mid: 邀请人id
    **/
    bindPhone: createBaseClient('POST', '/v1/member'),
    // 0066 - 登录
    login: createBaseClient('POST', '/v1/member', { action: 'login' }),
    // 0011.2 - 授权登录
    oauth: ({ route = '', mp = '' } = { route: '', mp: '' }) => {
      // 记录用户进行了 oauth 操作，以便后续决定是否要接受 token
      localStorage.setItem('oauth', 'true');

      const host = route
        ? window.location.host + route
        : window.location.host + window.location.pathname;

      let plat = '';
      let platName = '';

      if (mp) {
        plat = 'wp';
        platName = mp;
      }

      const url =
        API.OAUTH_URL +
        `?host=${encodeURIComponent(host)}&plat_name=${platName}&plat=${plat}`;

      window.location.href = url;
    },
    /**
     * 购买积分
     *  0126
     */
    purchaseScores: createBaseClient('GET', '/v1/score', MP_PLATFORM),
    /**
     * 积分配置
     * 0165
     *
     */
    scoresConfig: createBaseClient('GET', '/v1/config'),
    /**
     * 积分充值列表
     * 0125
     */
    scoresRechargeList: createBaseClient('GET', '/v1/score', PLATFORM),
    // 0061 - 用户信息
    userinfo: createBaseClient('GET', '/v1/member', PLATFORM),
    // 0015 - 微信签名
    weixinSign: createBaseClient('GET', '/v1/weixin', MP_PLATFORM),




    /**
     * 0014-招聘管理
     */
    manage: createJobClient('GET', '/v1/job', { action: 'manage' }),
    /**
     * 0022-购买置顶
     * id:商品id, jid:招聘id
     */
    jobToTop: createJobClient('POST', '/v1/job', {...MP_PLATFORM, action: 'push'}),
    /**
     * 0021-置顶判断
     */
    jobCheckTop: createJobClient('GET', '/v1/job', {action: 'check'}),
  }
};

export default apiClient;
